// App entitlements ("is this app installed for this org").
//
// Most apps ship always-on (DEFAULT_INSTALLED_APPS) and are always available.
// Opt-in apps are NOT in that list — they must be explicitly installed from the
// Apps marketplace, which records them in the org's `business.installedApps`.
// The Calendar is an opt-in app: an org sees no calendar features until an
// admin installs it. It costs $50/month (OD-1200) unless the org is
// grandfathered in `business.freeApps` (active Time Management accounts).

// Apps that ship installed for everyone (not opt-in). Calendar is intentionally
// NOT here — it is installed from the marketplace.
export const DEFAULT_INSTALLED_APPS = [
  "skai",
  "evv",
  "time",
  "billing",
  "command",
  "medication",
  "notes",
  "task",
  "invoice",
];

// Opt-in apps installed by the org live on the business record (org-wide, so
// staff inherit). Fall back to legacy user-level fields just in case.
const installedList = (profile) =>
  profile?.business?.installedApps ||
  profile?.user?.installedApps ||
  profile?.installedApps ||
  [];

/**
 * Is `appKey` installed for the given profile's org?
 * Always-on apps are always installed; opt-in apps require an explicit entry
 * in the org's installedApps list.
 */
export function isAppInstalled(profile, appKey) {
  if (DEFAULT_INSTALLED_APPS.includes(appKey)) return true;
  const installed = installedList(profile);
  return Array.isArray(installed) && installed.includes(appKey);
}

// Monthly list price for paid marketplace apps (mirrors the backend catalog in
// services/app.service.js — the server is the billing source of truth).
export const APP_MONTHLY_PRICES = {
  calendar: 50,
};

/**
 * Is `appKey` free for this org? Grandfathered orgs (OD-1200: active Time
 * Management accounts at rollout) carry the app in `business.freeApps`.
 */
export function isAppFree(profile, appKey) {
  const free = profile?.business?.freeApps || [];
  return Array.isArray(free) && free.includes(appKey);
}

/** Monthly price this org pays for `appKey`: $0 when grandfathered. */
export function appMonthlyPrice(profile, appKey) {
  if (isAppFree(profile, appKey)) return 0;
  return APP_MONTHLY_PRICES[appKey] ?? 0;
}
